import React from "react"
import { Routes, Route } from "react-router-dom"
import Home from "./home/Home"
// import End from "./end/End"
import More from "./more/More"
import Error from "./error/Error"
import ConfigContainer from "./components/config/Container"

const App = () => (
  <ConfigContainer>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/cnpj/:cnpj/cpf/:cpf" element={<More />} />
      <Route path="/cpf/:cpf" element={<More />} />
      <Route path="/error" element={<Error />} />
    </Routes>
  </ConfigContainer>

)

export default App
